import { Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../../../reusable-components/iconify/Iconify';

SectionHeader.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool,
    setOpen: PropTypes.func,
}

export default function SectionHeader({ title, open, setOpen }) {

    return (
        <Grid container justifyContent="space-between">
            <Typography align="left" variant="body1" color="info.main" sx={{ mb: 1 }}>
                {title}
            </Typography>
            <IconButton onClick={() => setOpen(o => !o)} >
                <Iconify color="info" icon={open ? 'mdi:chevron-up' : 'mdi:chevron-down'} width={16} height={16} />
            </IconButton>
        </Grid >
    );
}
